import { Report1917 } from "../../../components/borrowSystem/Report/Report1917";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report1917Container() {
  const titleName =
    " รายงานแบบสรุปแบบติดตามประเมินผลการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report1917 />
      <Footer />
    </div>
  );
}
